import { FC } from 'react';
import cn from 'classnames';

import HtmlContent from '@components/HtmlContent/HtmlContent';

import { IRichContentProps } from './RichContent.interface';

import './style.scss';

const RichContent: FC<IRichContentProps> = ({ className, children }) => (
  <div className={cn('rich-content', className)}>
    <HtmlContent>{children}</HtmlContent>
  </div>
);

export default RichContent;
